import { Fragment } from 'react';
import IMTHome from '../images/about1.jpg';
import './pages.css';
import aboutUS2 from '../images/crane-grab-scrap.jpg';
import aboutUS3 from '../images/about4.jpg';
import aboutUS4 from '../images/about5.jpg';
import aboutUS5 from '../images/aboutUS5.PNG';
import Footer from '../pages/Footer';
import ExpandableSection from "./ExpandableSection";

const AboutUs = () => {
    return (
        <Fragment>
            <img src={ IMTHome } className="avatar-home" alt="avatar" />
            <div className={ 'home-content' }>
                <div className={ 'company-content-container' }>
                    <p>We are a leading company in the marketing, management and export of industrial surpluses of mining and energy 
                       origin and projects related to metallic and ferrous surpluses. We have extensive experience in the Chilean market 
                       and a solid client portfolio that includes Codelco Chile and other large companies.
                    </p>
                </div>
                <div className={ 'what-content-container' }>
                    <div className={ 'what-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>Why Vanadium?</h2>
                        <hr size="2" color="blue" />
                        <ul className="what-content-list">
                            <li>Global Market Exposure</li>
                            <li>Strong Supplier Network</li>
                            <li> Effortless Handling of Logistics and Paperwork</li>
                            <li>Unbending Quality Control</li>
                            <li>Outstanding Customer Support Service</li>
                        </ul>
                    </div>
                    <img align="right" src={ aboutUS2 } className="avatar aboutUs2_Image" alt="avatar" width="300px" height="270px" />
                </div>
                <div className={ 'what-content-container' }>
                    <div className={ 'what-content aboutUs3-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>We Offer Unmatched Business Advantage</h2>
                        <hr size="2" color="blue" />
                        <ul className="what-content-list">
                            <li>Cost reduction: We help you reduce the costs associated with the disposal of your industrial surplus.</li>
                            <li>Greater efficiency: We optimize the management of your surpluses, freeing up resources so you can focus 
                                on your core business.
                            </li>
                            <li>Improving your environmental image: We help you improve your environmental image by giving your surplus 
                                a responsible final destination.
                            </li>
                            <li>Access to new markets: We open the doors to new markets for the commercialization of your surpluses.</li>
                        </ul>
                    </div>
                    <img align="right" src={ aboutUS3 } className="avatar" alt="avatar" width="300px" height="270px" />
                </div>
                <div className={ 'what-content-container' }>
                    <div className={ 'what-content aboutUs3-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>Our Value Proposition</h2>
                        <hr size="2" color="blue" />
                        <p>We offer our clients a comprehensive solution for the management of their
                           industrial surpluses, from collection and classification to marketing and  
                           export. We have a 6,000 m2 plant in San Bernardo equipped with state-of-the-art  
                           technology for the processing and management of surpluses for export worldwide.
                        </p>
                    </div>
                    <img align="right" src={ aboutUS4 } className="avatar" alt="avatar" width="300px" height="270px" />
                </div>
            </div>
            <Footer />
        </Fragment>
    )
};
export default AboutUs;
